export const serviceFaqSearchParam = 'vind';

export interface ServiceFormData {
    question: string;
}
